import '@fontsource/space-grotesk/400.css';
import '@fontsource/space-grotesk/500.css';
import '@fontsource/space-grotesk/700.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

const viewMode =
  typeof window !== 'undefined'
    ? new URLSearchParams(window.location.search).get('view') ??
      (window.location.pathname.startsWith('/root-console') ? 'license-host' : null)
    : null;

if (viewMode === 'tray-card') {
  document.documentElement.classList.add('tray-card-view');
  document.body.classList.add('tray-card-view');
  document.getElementById('root')?.classList.add('tray-card-root');
}

if (viewMode === 'floating-widget') {
  document.documentElement.classList.add('floating-widget-view');
  document.body.classList.add('floating-widget-view');
  document.getElementById('root')?.classList.add('floating-widget-root');
  document.title = 'AINIVOX - OAuth切换中心 Floating Widget';
}

if (viewMode === 'license-host') {
  document.title = 'AINIVOX - OAuth切换中心 License Host';
}

const isPackagedWindowsView =
  typeof window !== 'undefined' &&
  window.location.protocol === 'file:' &&
  /Windows/i.test(window.navigator.userAgent);

if (isPackagedWindowsView) {
  document.documentElement.classList.add('packaged-windows-material');
  document.body.classList.add('packaged-windows-material');
  document.getElementById('root')?.classList.add('packaged-windows-material-root');
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
